export default __webpack_public_path__ + "1b7da93b8e420ec6d6af6d51da005997.png";